(function(algolia) {
  'use strict';
  algolia.translations = {
    search: theme.strings.collections.search,
    noCollectionFound: theme.strings.collections.noCollectionFound,
    allProducts: theme.strings.collections.allProducts,
    matching: theme.strings.collections.matching,
    sortBy: theme.strings.collections.sortBy,
    relevance: theme.strings.collections.relevance,
    outOf: theme.strings.collections.outOf,
    resultsFound: theme.strings.collections.resultsFound,
    oneResultFound: theme.strings.collections.oneResultFound,
    noResultFound: theme.strings.collections.noResultFound,
    addToCart: theme.strings.collections.addToCart,
    searchForProduct: theme.strings.collections.searchForProduct,
    selectedFilter: theme.strings.collections.selectedFilter,
    clearAll: theme.strings.collections.clearAll,
    noPageFound: theme.strings.collections.noPageFound,
    outOfStock: theme.strings.collections.outOfStock,
    hasLabs: theme.strings.haslab || 'HasLab',
    preSale: theme.strings.preSale || 'Pre-order',
    soldOut: theme.strings.soldOut || 'Sold out',
    vault: theme.strings.vault || 'Vault',
    comingSoon: theme.strings.comingSoon || 'Cming Soon',
    teamUpSeries: theme.strings.teamUpSeries || 'Team-up Series',
    backCampaign: theme.strings.collections.backCampaign || "View The Campaign",
    inventoryFilterLabel: theme.strings.collections.inventoryFilterLabel,
    inventoryInStock: theme.strings.collections.inventoryInStock,
    quickAddLimit: theme.strings.collections.quickAddLimit
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return window.theme.strings.collections.noResultsQuery
        .replace('[[ query ]]', render(text));
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    query: function() {
      if (this.query) {
        return 'for "' + this.query + '"';
      }
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    try_clear_filters: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Please try ' +
        render(html_tags[0]) +
        ' clearing filters '
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
